import { ActionCreator } from 'src/app/helpers/redux';

export const LayoutActionCreators = {
  hideLoading: new ActionCreator<'layout/HideLoading', void>('layout/HideLoading'),
  showLoading: new ActionCreator<'layout/ShowLoading', void>('layout/ShowLoading')
};
